import { PopStateData } from "../interface";

export const backHandler = {
    register: (popStateHandler: () => void) => window.addEventListener("popstate", popStateHandler, false),
    push: (data: PopStateData, replace: boolean = false) =>
        replace ? window.history.replaceState(data, "", undefined) : window.history.pushState(data, "", undefined),
    handleBack: () => window.history.back(),
};
